<template>
  <v-dialog v-model="show" persistent max-width="500">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-btn color="error" plain @click="onCancel">
          {{ cancelText }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn tile large color="primary" @click="onConfirm">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    color: { type: String, default: 'error' },
    title: { type: String, default: 'Confirm' },
    text: { type: String, default: 'Are you sure?' },
    confirmText: { type: String, default: 'Yes, Delete' },
    cancelText: { type: String, default: 'Cancel' },
    value: Boolean
  },
  data() {
    return {}
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dialog(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.show = val
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
      this.show = false
    },
    onCancel() {
      this.$emit('cancel')
      this.show = false
    }
  }
}
</script>

<style></style>
